// OrderItem.js
import React from "react";

// MUI components
import { Box, Typography } from "@material-ui/core";

// MUI icons
import { Schedule } from "@material-ui/icons";

// // Local components
import { OrderSection } from "./OrderSection";

// Styled components / styles
import { EmptyState } from "../styles";
import { getNowByTerminal } from "utils/datetime";
import { useTerminalsContext } from "contexts/TerminalsProvider";

export const BusyPortOrders = ({ terminal_id, orders, translate }) => {
	const { data: terminals } = useTerminalsContext();
	const now = getNowByTerminal(terminals[terminal_id]);

	// Separate orders into occupied (current) and coming up (future)
	const occupiedOrders = [];
	const comingUpOrders = [];

	orders.forEach((orderData) => {
		const { port_section, order } = orderData;
		if (order.is_blocking_order) {
			occupiedOrders.push(orderData);
		} else {
			comingUpOrders.push(orderData);
		}
	});

	const hasOccupiedOrders = occupiedOrders.length > 0;
	const hasComingUpOrders = comingUpOrders.length > 0;
	const hasNoOrders = !hasOccupiedOrders && !hasComingUpOrders;

	if (hasNoOrders) {
		return (
			<EmptyState>
				<Schedule style={{ fontSize: 20, marginBottom: 6, color: "#9ca3af" }} />
				<Typography style={{ fontSize: "12px", color: "#6b7280" }}>{translate("resources.dashboard_ports.port.no_upcoming_orders")}</Typography>
			</EmptyState>
		);
	}

	return (
		<>
			<OrderSection title={translate("resources.dashboard_ports.port.occupied_by_following_orders")} orders={occupiedOrders} titleColor="#dc2626" />
			{hasOccupiedOrders && hasComingUpOrders && <Box style={{ height: "12px" }} />}
			<OrderSection title={translate("resources.dashboard_ports.port.upcoming_orders")} orders={comingUpOrders} />
		</>
	);
};
